module.exports = __webpack_public_path__ + "img/divider.06c76db1.svg";